<template lang="html">

    <section class="producto-home -caramelos column-center">

        <div class="container container-title animation">
            <!-- <h1 class="big-title animation" id="titulo-split" data-splitting="chars">{{$t('header.patatas')}}</h1> -->
            <h2 class="big-title animation" id="titulo-split">{{$t('header.patatas')}}</h2>
        </div>

        <div class="contenedor-ruleta">
            <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.selectas')" :activo="select == 'frutos-secos'" @mouseover.native="select = 'frutos-secos'" class="boton" data="frutos-secos">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/logo-selectas.svg'" alt="Originales">
            </router-link>

            <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.originales')" :activo="select == 'pipas'" @mouseover.native="select = 'pipas'" class="boton" data="pipas">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/originales-logo.svg'" alt="Selectas">
            </router-link>



            <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.onduladas')" :activo="select == 'natura'" @mouseover.native="select = 'natura'" class="boton" data="natura">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/logo-onduladas.svg'" alt="Onduladas">
            </router-link>



            <div class="contenedor-imagen row-center">


                <img alt="imagen producto  inicial" v-show="select == 'pipas'" class="animated zoomInUp" :src="'/static/img/ruleta-home/patatas/originales.png'">
                <img alt="imagen producto  caramelos" v-show="select == 'frutos-secos'" class="animated zoomInUp" :src="'/static/img/ruleta-home/patatas/selectas.png'">
                <img alt="imagen producto 0-azucares" v-show="select == 'natura'" class="animated zoomInUp" :src="'/static/img/ruleta-home/patatas/onduladas.png'">


            </div>

        </div>

        <div class="contenedor-boton">
            <espiral class="espiral-ani" delay="0"></espiral>
            <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.patatas')" class="btn -action waypoints" v-html="$t('todosNuestrasPatatas')"></span>
            </router-link>
        </div>

        <img :src="'/static/img/patatas/'+$i18n.locale+'/patatas-intro.png'" alt="Patatas" class="intro-patatas">
        <img :src="'/static/img/patatas/'+$i18n.locale+'/patata-toscana.png'" alt="patata-toscana" class="patata-toscana">
        <img :src="'/static/img/patatas/'+$i18n.locale+'/patatas-onduladas-sal.png'" alt="patatas-onduladas-sal" class="patatas-onduladas-sal">




    </section>

</template>

<script lang="js">

    import espiral from '@/components/parts/icons/espiral'

    export default {
        name: 'modulo-caramelos',
        data() {
            return {
                select: 'frutos-secos',
            }
        },
        components: {
            'espiral': espiral
        }

    }
</script>

<style scoped lang="scss">
    .producto-home {
        background: linear-gradient(180deg, #C7D42E 19.15%, #A7BC38 94.17%);
    }

    .patata-toscana {
        position: absolute;
        left: 50%;
        margin-left: -500px;
        bottom: -100px;
    }

    .patatas-onduladas-sal {
        position: absolute;
        right: -100px;
        top: 100px;
    }

    .big-title {
        font-size: 160px;
    }

    .boton {
        &[data=frutos-secos] {
            left: 50%;
            bottom: 0;
            margin-left: -185px;
            width: 370px;
        }

        &[data="pipas"] {
            left: 0;
            top: 50%;
            margin-top: -60px;
            width: 239px;
        }

        &[data="natura"] {
            top: 50%;
            margin-top: -60px;
            right: 0;
            width: 160px;
        }
    }


    h3 {
        font-size: 33px;
        text-transform: uppercase;
        color: #fff;
        font-family: 'Futura LT CondensedExtraBold';
        line-height: 1.2em;
        transform: rotate(-9deg);

        strong {
            font-family: 'Futura LT CondensedExtraBold';
            font-size: 65px;
            line-height: 1em;
        }
    }

    .btn {
        font-size: 54px;
        color: #A7BC38;
        max-width: fit-content;
        height: 80px;
        line-height: 70px;

        span {
            font-size: 16px;
            color: #A7BC38;
        }
    }

    .intro-patatas {
        position: absolute;
        left: -50px;
        top: 50%;
        transform: translateY(-50%);
    }

    .contenedor-texto {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 200px;
        height: 300px;
        padding-top: 200px;
        transform: rotate(10deg);

        .contenedor-espiral {
            position: absolute;
            left: 60px;
            top: 20px;
            transform: scale(.8) rotate(20deg);
        }

        p {
            font-size: 36px;
            color: white;
            display: inline-block;
            line-height: 30px;
            margin-top: 30px;
            animation-delay: 2s;
        }
    }



    @media screen and (max-width: 1220px) {

        .patatas-onduladas-sal {
            right: -200px;
        }

    }

    @media screen and (max-width: 900px) {
        .contenedor-texto {
            display: none;
        }

        .big-title {
            font-size: 90px;
        }


        .boton {
            &[data=frutos-secos] {
                width: 33.3333%;
            }

            &[data="pipas"] {
                width: 33.3333%;
            }

            &[data="natura"] {
                width: 33.3333%;
            }
        }

        .intro-patatas {
            max-width: 200px;
            transform: none;
            top: -100px;
        }

        .patata-toscana {
            max-width: 200px;
            margin-left: 0;
            left: -50px;
            bottom: -40px;
        }

        .patatas-onduladas-sal {
            max-width: 250px;
            top: 0;
            right: -100px;
        }

    }


    @media screen and (max-width: 560px) {
        .big-title {
            font-size: 50px;
        }

        .boton {
            &[data=frutos-secos] {
                width: 100%;
            }

            &[data="pipas"] {
                width: 100%;
            }

            &[data="natura"] {
                width: 100%;
            }
        }

        .intro-patatas {
            max-width: 200px;
            transform: none;
            top: -100px;
            left: -100px;
        }

        .patata-toscana {
            max-width: 200px;
            margin-left: 0;
            left: -70px;
            bottom: -80px;
        }

        .patatas-onduladas-sal {
            max-width: 250px;
            top: 0;
            right: -150px;
        }


    }
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-patatas.vue